export enum Role {
  Role = 'role',
}